// Expected to be interoperable with https://bitbucket.hq.netspend.com/projects/APP/repos/netspend-ui-utils/browse/src/core/ns-storage-provider.js#34-42

export const encode = (payload: any) => window.btoa(JSON.stringify(payload));

export const decode = (encodedPayload: string) => {
  return JSON.parse(window.atob(encodedPayload));
};
